/** The newest `updatedAt` of a delta, the start of the next delta sync. Unchanged if the delta is empty. */
export function calculateNewWatermark(
  lastWatermark: string | undefined,
  delta: readonly { updatedAt?: string | null }[],
): string | undefined {
  const maxUpdatedAt = delta.reduce(
    (max, entry) => {
      if (!entry.updatedAt) return max;
      if (!max) return entry.updatedAt;
      return new Date(entry.updatedAt).getTime() > new Date(max).getTime()
        ? entry.updatedAt
        : max;
    },
    undefined as string | undefined,
  );
  return maxUpdatedAt ?? lastWatermark;
}
